export function getWebsiteURL(website_id) {
    return website_id == 1 ? "" : "/international";
}

export function getBreadCrumbURL(website_id){
  return (website_id == 1) ? "/" : "/international/";
}